var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 146.358994, 113.460999)",
    paintOrder: "fill markers stroke"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m118.507 133.514-34.249 34.249-15.968-15.968-41.938 41.937H178.726z",
    opacity: 0.675,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.217,
    cy: 108.555,
    r: 11.773,
    opacity: 0.675,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.111 77.634h152.614v116.099H26.111z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.ebbef7ba00a902c577e7e6aa691a2372.svg";
export { ForwardRef as ReactComponent };